export const ModalCustomization = {
  bodyClasses: "rounded-5 bg-white overflow-visible",
  buttonClasses: "border-none focus:outline-none text-body-dark bg-body h-8 w-8 rounded-full p-1",
  position: "right",
  size: "large",
};

export const ModalCustomizationWithoutPaddingSmall = {
  bodyClasses: "rounded-10 bg-white overflow-hidden w-fit",
  buttonClasses:
    "border-none focus:outline-none text-dark-text bg-body h-8 w-8 rounded-full p-1",
  innerPadding: "p-0",
  size: "extraLarge",
};